import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      x: "0.5",
      y: "0.5",
      width: "39",
      height: "39",
      rx: "19.5",
      fill: "white"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M16.2929 11.7929C16.6834 11.4024 17.3166 11.4024 17.7071 11.7929L25.2071 19.2929C25.5976 19.6834 25.5976 20.3166 25.2071 20.7071L17.7071 28.2071C17.3166 28.5976 16.6834 28.5976 16.2929 28.2071C15.9024 27.8166 15.9024 27.1834 16.2929 26.7929L23.0858 20L16.2929 13.2071C15.9024 12.8166 15.9024 12.1834 16.2929 11.7929Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("rect", {
      x: "0.5",
      y: "0.5",
      width: "39",
      height: "39",
      rx: "19.5",
      stroke: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }